// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__286QP","errors":"Errors_errors__1Y2Fe"};